/**
 * some common constants
 */

/**
 * the name of the default configuration
 */
const DEFAULT_CONFIG = '@default';

/**
 * the name of configuration's root node
 */
const ROOT_NODE_NAME = '@rootNode';

export { DEFAULT_CONFIG, ROOT_NODE_NAME };
